import { Notification } from 'element-ui';
import { isObject, isString } from './is';

/**
 * 显示消息
 * @param options el-notification 配置项
 */
export const showToast = options => {
  options = isString(options) ? { type: 'success', message: options } : options;
  let title = '提示';
  if (isObject(options) && options.type && options.type === 'success') {
    title = '成功';
  }
  Notification({
    title,
    ...options,
    duration: 3000
  });
};
